import Stepper from "src/components/Stepper/Stepper";
import { defaultRenderIcon } from "src/components/Stepper/constants";
import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos } from "react-icons/md";

export default function JourneyDetailsStepper() {
  const { t } = useTranslation();
  const { goToStep, currentStepIndex, isStepAllowed, steps } = useStepFlow();
  const { searchId } = useParams();
  const handleChange = (index: number) => {
    goToStep(steps[index].value);
  };
  const handleStepStatusChange = (index: number) => {
    if (!isStepAllowed(steps[index].value)) return "disabled";
    if (index < currentStepIndex) return "completed";
    if (index === currentStepIndex) return "current";
    return "upcoming";
  };
  return (
    <Stepper
      disableNav={false}
      currentStep={currentStepIndex}
      steps={steps}
      onStepChange={handleChange}
      onBackNode={
        <Link to={`/travel/tickets/${searchId}`} className="flex shrink-0 items-center gap-1 font-semibold! text-font-minimal! hover:text-font-active!">
          <MdArrowBackIos className="rtl:-scale-x-100" />
          {t("UserHistory.common.back")}
        </Link>
      }
      getStepStatus={handleStepStatusChange}
      renderStepIcon={({ status, index }) => {
        if (status === "disabled") return null;
        return defaultRenderIcon({ index, status });
      }}
      classNames={{
        item: "text-font-minimal data-[status=current]:border data-[status=current]:text-font-active! border-border-active border-dashed font-semibold rounded-md px-4 py-1 flex items-center data-[status=completed]:text-font-active!",
        icon: "rounded-full! data-[status=disabled]:border-border-subtle items-center jusitfy-center flex p-1 data-[status=completed]:bg-icon-active! data-[status=completed]:text-icon-inverted!",
        connector: {
          rail: "bg-border-active h-[1px]!",
        },
        root:"w-full"
      }}
    />
  );
}
